<div class="basket-shell-back" (click)="onShellClick($event)" [ngClass]="{ 'expanded': expanded }" *ngIf="itemCount > 0"></div>
<div class="basket-shell">
    <div class="basket-container" (click)="onContainerClick($event)" [ngClass]="{ 'shake': !expanded && notifyDelete }">
        <!-- <div class="basket-pending-container" [ngClass=]="{ 'expanded': pendingUpdate }"> -->
        <div class="basket-pending-container" *ngIf="pendingUpdateActive" [ngClass]="{ 'basket-pending-container-expanded': pendingUpdates > 0 }">
            <div class="basket-pending-container-label">
                Opdaterer kurv...
            </div>
            <div class="basket-pending-container-spinner">
                <app-ddk-spinner></app-ddk-spinner>
            </div>
        </div>
        <div class="basket-header col-12" *ngIf="itemCount > 0 && toast === true" [ngClass]="{ 'expanded': expanded }">
            <header class="basket-header-container" (click)="toggleExpanded()">
                <div class="row">
                    <div class="col-5 col-sm-6 basket-header-items">
                        <span class="bold" *ngIf="itemCount > 0">{{ itemCount }}</span><span > {{ itemName }}</span>
                    </div>
                    
                    <div class="col-7 col-sm-6 basket-header-cta">
                        <span>Se kurv og køb nu</span>
                    </div>
                    <div class="col-12 basket-header-content grow-big" [ngClass]="{'grow-small': basketNotify && itemCount > 1, 'grow-big': basketNotify && itemCount == 1 }">
                        <div class="row">
                            <div class="col-5 order-container">
                                <span class="order-number">1</span>
                                <span class="order-super">X</span>
                                <div class="order-icon order-icon-{{ addedItemType }} order-icon-{{ addedItemType }}--{{ addedItemNormalizedName }}"></div>
                            </div>
                            <div class="col-7 mb-2">
                                <h5>{{ addedItemName }}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
        <div class="basket-body col-12" *ngIf="itemCount > 0">
            <app-basket class="basket-body-container" *ngIf="itemCount > 0 && expanded"
                [navigate-checkout]="navigateCheckout"
                [payment-details]="false"
                [price-factor]="6"
                [theme]="'blue'"
                (onCloseClick)="toggleExpanded()"
            ></app-basket>
        </div>
    </div>
</div>
